import React from 'react';
import { Box, useTheme } from '@mui/material';
import { Accordion, ReactGridContainer } from '@europrocurement/flexy-components';

import TasksDashboardWidget from '../../components/TasksDashboardWidget/TasksDashboardWidget';

type FormalistDashboardProps = {
    title: string;
    userId: number;
};

export type DashboardFiltersType = {
    startedAt: string;
    endedAt?: string;
};

const InternDashboard: React.FunctionComponent<FormalistDashboardProps> = function ({
    title,
    userId,
}) {
    const { palette } = useTheme();

    return (
        <Accordion
            title={title}
            expandLabel
            expanded
            expandColor={palette.primary}
            sx={{ boxShadow: 'unset', border: 'none' }}
            contentSxProps={{ gap: '16px', display: 'grid' }}
        >
            <ReactGridContainer
                localStorageName="grid-intern-user"
                gridconfig={{ cols: 6, rowHeight: 30 }}
                layoutProps={[
                    {
                        i: 'list-tasks-intern',
                        x: 0,
                        y: 0,
                        w: 4,
                        h: 16,
                        isResizable: true,
                        resizeHandles: ['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'],
                    },
                ]}
            >
                <Box
                    key="list-tasks-intern"
                    sx={{
                        background: palette.background.paper,
                        borderRadius: '8px',
                        padding: '0px 8px',
                    }}
                >
                    <TasksDashboardWidget formalistIds={[userId]} />
                </Box>
            </ReactGridContainer>
        </Accordion>
    );
};

export default InternDashboard;
